import { jsx } from 'react/jsx-runtime';
import React__default from 'react';
import RowMenu from '../RowMenu/RowMenu.js';
import '../RowMenu/RowContextMenu.js';

const RowMenuRenderer = React__default.memo((props) => {
    return jsx(RowMenu, Object.assign({}, props));
});
RowMenuRenderer.displayName = 'RowMenuRenderer';

export { RowMenuRenderer as default };
//# sourceMappingURL=RowMenuRenderer.js.map
